/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {URLS} from "./api";
import {FetchMethod, ResponseData, sendFetch} from '@dvrd/dvr-controls';

interface Callback {
    callback: Function,
}

interface OptionalCallback {
    callback?: Function,
}

interface WithData<T> {
    data: T
}

/*
 ================================================
 AUTH
 ================================================
 */

interface LoginData {
    email: string;
    password: string;
}

export const login = (params: Callback & WithData<LoginData>) => {
    sendFetch({
        url: URLS.POST.LOGIN,
        method: FetchMethod.POST,
        data: params.data,
        callback: (data: ResponseData) => {
            params.callback(data);
        },
    });
};

/*
 ================================================
 USER
 ================================================
 */

export const getUser = (params: Callback) => {
    sendFetch({
        url: URLS.GET.USER,
        callback: params.callback,
    });
}

/*
 ================================================
 DOWNLOAD
 ================================================
 */

export const downloadUrl = (params: WithData<{ url: string }> & Callback) => {
    sendFetch({
        url: URLS.POST.DOWNLOAD_YT,
        method: FetchMethod.POST,
        data: params.data,
        callback: params.callback,
    });
};

/*
 ================================================
 Response util
 ================================================
 */